import { useAppSelector } from "../store/index.ts";

export default function useDecimalValue() {
  const balance = useAppSelector((state) => state.user.balance);

  const getDecimalValue = (val, currency) => {
    const decimal = balance[currency]?.info?.decimal || 0;
    if (!val) return 0;
    const fixedValue = Number(val)?.toFixed(decimal);

    if (!fixedValue) return 0;
    const displayValue = Number(fixedValue).toLocaleString();
    return displayValue || 0;
  };

  return getDecimalValue;
}
